import {
  BasicButton,
  BasicInput,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import { getDefaultValueForSelect } from "helpers/functionsHelpers";
import { useTransferForm } from "../hooks/useTransferForm";
import { ArrowLeftRight } from "lucide-react";

export const HeaderTransferForm = () => {
  const {
    //* Propesties
    t,
    destinyRows,
    originRows,
    formik,
    payloadTransfer,
    existProductsInStore,

    // * Methods
    setPayloadTransfer,
  } = useTransferForm();

  return (
    <>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
        }}
      >
        <div className="flex w-full items-center justify-end flex-wrap">
          <BasicButton onClick={() => {}} type="submit">
            <div className="flex flex-row justify-center items-center">
              <ArrowLeftRight size={16} color="#fff" />
              <span className="ml-2 text-slate-50">
                {t("transferBetweenWarehouse.addNewOptionBtn")}
              </span>
            </div>
          </BasicButton>
        </div>
        <div className="grid grid-cols-1 min-[768px]:grid-cols-12 gap-4">
          <div className="col-span-1 w-full min-[768px]:col-span-6">
            <SelectComponent
              label={t(
                "transferBetweenWarehouse.headerTransferForm.selectLabelWarehouseOrigin"
              )}
              placeholder={t(
                "transferBetweenWarehouse.headerTransferForm.selectPlaceholderWarehouseOrigin"
              )}
              options={originRows}
              id="providers"
              isMulti={false}
              value={getDefaultValueForSelect(originRows, formik.values.origin)}
              onChange={(option: OptionSelect) => {
                if (option && option.value) {
                  formik.setFieldValue("origin", option.value);
                  setPayloadTransfer({
                    ...payloadTransfer,
                    warehousefrom_id: Number(option.value),
                  });
                }
              }}
              isDisabled={existProductsInStore}
              isError={
                (formik.touched.origin && Boolean(formik.errors.origin)) ||
                false
              }
              errorMessage={formik.errors.origin || ""}
            />
          </div>
          <div className=" col-span-1 w-full min-[768px]:col-span-6">
            <SelectComponent
              label={t(
                "transferBetweenWarehouse.headerTransferForm.selectLabelWarehouseDestiny"
              )}
              placeholder={t(
                "transferBetweenWarehouse.headerTransferForm.selectPlaceholderWarehouseDestiny"
              )}
              options={destinyRows}
              id="providers"
              isMulti={false}
              value={getDefaultValueForSelect(
                destinyRows,
                formik.values.destiny
              )}
              onChange={(option: OptionSelect) => {
                if (option && option.value) {
                  formik.setFieldValue("destiny", option.value);
                  setPayloadTransfer({
                    ...payloadTransfer,
                    warehouseto_id: Number(option.value),
                  });
                }
              }}
              isDisabled={existProductsInStore}
              isError={
                (formik.touched.destiny && Boolean(formik.errors.destiny)) ||
                false
              }
              errorMessage={formik.errors.destiny || ""}
            />
          </div>
          <div className=" col-span-1 w-full min-[768px]:col-span-12">
            <BasicInput
              id="observations"
              label={t(
                "transferBetweenWarehouse.headerTransferForm.labelObservations"
              )}
              placeholder={t(
                "transferBetweenWarehouse.headerTransferForm.placeholderObservations"
              )}
              onBlur={formik.handleBlur}
              onChange={({ target }) => {
                formik.setFieldValue("observations", target.value);
                setPayloadTransfer({
                  ...payloadTransfer,
                  observation: target.value,
                });
              }}
              type="text"
              value={formik.values.observations}
              isError={
                (formik.touched.observations &&
                  Boolean(formik.errors.observations)) ||
                false
              }
              errorMessage={formik.errors.observations || ""}
              className="w-full h-20"
            ></BasicInput>
          </div>
        </div>
      </form>
    </>
  );
};
